// IMPORTANT! Polaris styles must come first
import '@shopify/polaris/build/esm/styles.css'
// Local styles - order matters for CSS variable cascade
import './index.css'
import './polaris-overrides.css'
import './components/components.css'
import './features/features.css'

import { CacheProvider } from '@rest-hooks/react'
import { AppProvider } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
// Third-party libraries
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Link } from 'react-router-dom'

// Local application modules
import App from './app/App'
import store from './app/store'
import PhilipsShield from './assets/images/PhilipsShield.svg'
import * as serviceWorker from './serviceWorker'

const root = createRoot(document.getElementById('root'))

const theme = {
  colors: {
    surface: '#00000000',
    onSurface: '#00000000',
    interactive: '#00000000',
    topBar: {
      background: '#0b2265',
      backgroundLighter: '#005a8b',
      backgroundDarker: '#0039a6',
      border: '#5d5d5d',
      color: '#ffffff'
    }
  },
  logo: {
    width: 32,
    topBarSource: PhilipsShield,
    url: '/',
    accessibilityLabel: 'Philips'
  }
}

// Router-aware link component for Polaris
function PolarisLink({ children, url = '', external, ...rest }) {
  if (external) {
    return <a href={url} {...rest}>{children}</a>
  }
  return <Link to={url} {...rest}>{children}</Link>
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <CacheProvider>
          <AppProvider i18n={enTranslations} theme={theme} linkComponent={PolarisLink}>
            <App />
          </AppProvider>
        </CacheProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)

serviceWorker.unregister()